import * as processUI from '../process-ui'
import * as processAction from '../process-action'


export const createUIDefinition = ({ taskName, stateNameList = [], external = false, widgetList = [], overwriteWidget = false, actionList = [], taskValidatorSelector = [], taskValidator = null }) => {
    return {
        external,
        taskName,
        stateNameList,
        widgetList: !overwriteWidget ? [
            {
                component: processUI.OVERVIEW,
            },
            {
                component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
            },
            ...widgetList,
            {
                component: processUI.COMMENT_LIST,
            },
            {
                component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
            },
            {
                component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
            },
            {
                component: processUI.SENT_EMAIL_WIDGET,
            },
            {
                component: processUI.WHATSAPP_MESSAGES_WIDGET,
            },
            {
                component: processUI.INVOICE_LIST_WIDGET,
            },
            {
                component: processUI.PAYMENT_LIST_WIDGET,
            },
            {
                component: processUI.STATE_TRANSITION_LOG_CONTAINER,
            },
            {
                component: processUI.TECHNICAL_LOG_CONTAINER,
            },
        ] : widgetList,
        actionList: [
            ...actionList,
            {
                action: processAction.PROCESS_INSTANCE,
                taskPath: ['processInstance'],
            },
            {
                action: processAction.SALES_ORDER,
                taskPath: ['objectDetail'],
            },
            {
                action: processAction.CUSTOMER,
                taskPath: ['objectDetail', 'customer'],
            },
        ],
        taskValidatorSelector,
        taskValidator,
    }
}


export const defaultUI = createUIDefinition({})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/default-task-definition.js